import getByExerciseIdExerciseLogSummarySelector from '../get-by-exercise-id'
import { createSelector } from 'reselect'
import { EXERCISE_ID } from '../../../exercise/constants'

const getBarbellBenchPressExerciseLogSummarySelect = createSelector(
  getByExerciseIdExerciseLogSummarySelector(EXERCISE_ID.BARBELL_BENCH_PRESS),
  (instance) => instance
)

export default getBarbellBenchPressExerciseLogSummarySelect
